import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dd058cd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "vmodal-mask"
}
const _hoisted_2 = { class: "vmodal-wrapper" }
const _hoisted_3 = { class: "vmodal-container" }
const _hoisted_4 = { class: "close-vmodal" }
const _hoisted_5 = { class: "vmodal-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_close_icon = _resolveComponent("close-icon")!

  return (_openBlock(), _createBlock(_Transition, { name: "vmodal" }, {
    default: _withCtx(() => [
      (_ctx.showModal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, [
                  _createVNode(_component_close_icon, { onClick: _ctx.close }, null, 8, ["onClick"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}